import React from 'react';
import { createRoot } from 'react-dom/client';
import SharedSnippetsModal from './SharedSnippetsModal';
import {
  type SharedSnippetMode,
  type SharedSnippetReference,
} from '@aha-app/aha-editor-v2';

export function openSharedSnippetsModal(params: {
  callback: (
    snippetReference: SharedSnippetReference,
    options: { open?: boolean }
  ) => void;
  onCreateSharedSnippet?: (
    mode: SharedSnippetMode
  ) => Promise<SharedSnippetReference | undefined>;
  reactiveUrl?: string;
}) {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const root = createRoot(container);

  function closeModal() {
    root.unmount();
    container.remove();
  }

  const content = (
    <SharedSnippetsModal
      onClose={closeModal}
      onSelectSnippet={(snippetReference, options) => {
        params.callback(snippetReference, options);
        closeModal();
      }}
      onCreateSharedSnippet={params.onCreateSharedSnippet}
      reactiveUrl={params.reactiveUrl || '/shared_snippets.modal'}
    />
  );

  root.render(content);
}
